import { ICaptionsItem } from '../../../../../types/common';

// a fresh object per click, so clicking the same time twice still re-scrolls to it;
// index — a line clicked in the transcript itself (two lines can start within the same second)
export type TTranscriptHighlight = { time: number } | { index: number };

// AI timestamps are whole seconds, so match the last line starting at or before that second
export const findCaptionIndexAt = (captions: ICaptionsItem[], time: number): number => {
	let index = -1;
	captions.forEach((c, i) => { if (Math.floor(c.startTime) <= time) index = i; });
	return index;
};

export interface ILessonTranscriptOwnProps {
	highlight: TTranscriptHighlight | null;
	onLineClick: (index: number) => void;
}

export interface ILessonTranscriptFields {
	captions: ICaptionsItem[];
	isPlaying: boolean | null; // null — unknown (text lesson), no play/pause mark
}

export interface ILessonTranscriptProps extends
	ILessonTranscriptOwnProps,
	ILessonTranscriptFields
{}
